export const MAX_TAGS = 20
export const MAX_TAG_LENGTH = 200
